export enum StaticColorVariant {
  Slate = 'slate',
  Gray = 'gray',
  Zinc = 'zinc',
  Neutral = 'neutral',
  Stone = 'stone',
  Red = 'red',
  Orange = 'orange',
  Amber = 'amber',
  Yellow = 'yellow',
  Lime = 'lime',
  Green = 'green',
  Emerald = 'emerald',
  Teal = 'teal',
  Cyan = 'cyan',
  Sky = 'sky',
  Blue = 'blue',
  Indigo = 'indigo',
  Violet = 'violet',
  Purple = 'purple',
  Fuchsia = 'fuchsia',
  Pink = 'pink',
  Rose = 'rose',
}

export function projectPlanColor(plan: string): StaticColorVariant {
  switch (plan.toUpperCase()) {
    case 'ELITE':
      return StaticColorVariant.Purple
    case 'PREMIUM':
      return StaticColorVariant.Sky
    case 'PRO':
      return StaticColorVariant.Lime
    case 'FREE':
    default:
      return StaticColorVariant.Yellow
  }
}
